module.exports = __webpack_public_path__ + "img/green_hover.b3227e16.png";